<form
  novalidate
  [formGroup]="radiusServerForm"
  #currentForm="ngForm"
  *ngIf="!wizardCtrl.getWizardService()?.isLoading"
>
  <div class="group parent-input-width">
    <p class="label">Host *</p>
    <input
      autocomplete="off"
      matInput
      class="hostname input-width width-50"
      [(ngModel)]="host"
      formControlName="host"
      maxlength="80"
      (ngModelChange)="hostUpdated()"
    />
    <div class="error" *ngIf="hostname.invalid && (hostname.dirty || hostname.touched)">
      <mat-error *ngIf="radiusServerForm.hasError('required', 'host')">Host is required</mat-error>
    </div>
    <div class="error" *ngIf="hostname.invalid">
      <mat-error *ngIf="radiusServerForm.hasError('matchPattern', 'host')"
        >Host is invalid</mat-error
      >
      <mat-error *ngIf="radiusServerForm.hasError('maxlength', 'host')">Host is too long</mat-error>
    </div>
  </div>

  <div>
    <div class="group parent-input-width">
      <p class="label">Port *</p>

      <input
        autocomplete="off"
        matInput
        class="port input-width"
        type="number"
        [(ngModel)]="port"
        formControlName="port"
        (ngModelChange)="portUpdated()"
      />
      <div class="error" *ngIf="portNumber.invalid && portNumber.touched">
        <mat-error *ngIf="radiusServerForm.hasError('required', 'port')"
          >Port is required</mat-error
        >
      </div>
      <div class="error" *ngIf="portNumber.invalid">
        <mat-error
          *ngIf="
            radiusServerForm.hasError('max', 'port') || radiusServerForm.hasError('min', 'port')
          "
          >Port should be between 1 and 65535</mat-error
        >
      </div>
    </div>
    <div class="group parent-input-width">
      <p class="label">NAS Identifier *</p>

      <input
        matInput
        class="input-width width-50"
        type="text"
        [(ngModel)]="nasIdentifier"
        formControlName="nasIdentifier"
        (ngModelChange)="nasIdentifierUpdated()"
      />
      <div class="error" *ngIf="nasIdentifierInput.invalid && nasIdentifierInput.touched">
        <mat-error *ngIf="radiusServerForm.hasError('required', 'nasIdentifier')"
          >NAS Identifier is required</mat-error
        >
      </div>
    </div>

    <div class="group parent-input-width">
      <p class="label">Secret *</p>

      <input
        matInput
        class="input-width width-50"
        type="password"
        [(ngModel)]="secret"
        autocomplete="new-password"
        formControlName="secret"
        (ngModelChange)="secretUpdated()"
      />
      <div class="error" *ngIf="secretInput.invalid && secretInput.touched">
        <mat-error *ngIf="radiusServerForm.hasError('required', 'secret')"
          >Secret is required</mat-error
        >
      </div>
    </div>
    <div class="enable-input">
      <label class="enable-accounting">Enable Accounting</label>
      <mat-slide-toggle
        color="primary"
        (change)="accountingEnabledUpdated()"
        [checked]="accountingEnabled"
      ></mat-slide-toggle>
    </div>
    <div class="group parent-input-width" *ngIf="accountingEnabled">
      <p class="label">Accounting Port *</p>

      <input
        autocomplete="off"
        matInput
        class="port input-width"
        type="number"
        [(ngModel)]="accountingPort"
        formControlName="accountingPort"
        (ngModelChange)="accountingPortUpdated()"
      />
      <div class="error" *ngIf="accountingPortInput.invalid && accountingPortInput.touched">
        <mat-error *ngIf="radiusServerForm.hasError('required', 'accountingPort')"
          >Accounting port is required</mat-error
        >
      </div>
      <div class="error" *ngIf="accountingPortInput.invalid">
        <mat-error
          *ngIf="
            radiusServerForm.hasError('max', 'accountingPort') ||
            radiusServerForm.hasError('min', 'accountingPort')
          "
          >Accounting port should be between 1 and 65535</mat-error
        >
      </div>
    </div>
  </div>
</form>

<div *ngIf="wizardCtrl.getWizardService()?.isLoading" class="loader">
  <mat-spinner></mat-spinner>
  <p class="loader-msg">One moment...</p>
</div>
